<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  /* height: 120px; */
  border-radius: 10px;

}
.card-flex{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.order-flex{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.card-flex-price{
    display: flex;
    align-items: center;
}
.card-flex-count{
    display: flex;
    align-items: center;
    justify-content: right;
}
.new-card{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    border-radius: 10px;
    margin: 5px;
    padding: 20px 5px;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.new-card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.d-none-width {
    width: 250px; 
    max-width: 250px; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.d-none-price {
    width: 200px;
}
.p-relative{
    position: relative;
}
.add-cart-button{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background-color: #0057AD;
    border-radius: 50%;
}
.deliver{
    border:solid 1px #e3e3e3;
    border-radius:10px;
    display: flex;
    padding: 20px;
    align-items: center;
    margin: 10px 4px 10px 4px;
}
.info-input{
   border: solid 1px #d2d4d6;
   border-radius: 30px;
   padding: 10px 15px;
   width: 100%;
   height: 30px;
   -moz-appearance: textfield;
}
.info-input::-webkit-outer-spin-button,
.info-input::-webkit-inner-spin-button {
  -webkit-appearance: none; /* Chrome-д тооны сум арилгах */
  margin: 0;
}
.info-img{
    width: 25px;
    height: auto;
    margin-right: 5px
}
.info-button{
    width:100%;
     border-radius: 12px;
     height: 30px;
     display: flex;
     justify-content: center;
     align-items: center;
}
.flex{
    display: flex;
}
.pass-show{
    appearance: none;
    position: absolute;
    top:0;
    right: 14px;
    cursor: pointer;
    content: url('../assets/images/logo/eye.png');
    width: 18px;
    height: 100%;
    opacity: 0.3;
}
.pass-show:checked{
    appearance: none;
    content: url('../assets/images/logo/hide.png');
}
.flex-info{
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
}
@media only screen and (max-width: 600px) {
    .card-phone {
        width: 89%;
    }
  .d-none-width {
    width: auto;
    max-width: 100%;
  }
  .d-none-link {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .d-none-price {
      width: auto;
  }
  .mobile-product {
      padding: 20px;
  }
  .order-none{
    display: none;
  }
}
</style>
<template>
    <div>
        <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="container">
                <div class="row" >
                     <div class="mb-2 cart-table col-md-8" style="overflow: auto;">
                        <div class="row"> 
                                 <span class="font-size-18 ml-4 ">Хадгалсан</span>
                                 <div class="col-12">
                                    <div class="deliver" style="background-color: #fad419;"> 
                                       <i class="ec ec-favorites font-size-24" style="width: 40px;height:100%; margin:0 10px;"></i>
                                            <span>Таны зүрх дарж хадгалсан бараа хямдарсан тохиолдолд бил танд цаг алдалгүй мэдэгдэх болно.</span>
                                    </div>
                                 </div>
                             </div>
                             <div class="row new-card" v-for="(item, index) in saved" :key="index"> 
                                 <div class="col-12 col-md-3">
                                         <div class="card-flex check" style="align-items: center;"><i class="ec ec-favorites font-size-24"></i><img class="img-fluid max-width-100 p-1 " :src="item.image" alt="Image Description"></div>
                                 </div>
                                 <div class="col-12 col-md-3 card-flex-price pl-4">
                                       <div> 
                                            <div class="text-gray-90 d-none-link"><span>{{item.name}}<br></span><strong>{{item.code}}</strong> #{{item.color_name}}</div>
                                        </div>
                                 </div>
                                 <div class="col-12 col-md-6 card-flex-price">
                                          <del class="col-4 font-size-20" style="margin-top: -4px" v-if="item.Regular_price_tug>item.price_tug">₮{{Number(item.Regular_price_tug).toLocaleString()}}</del>
                                           <span class="col-4 font-size-20" style="margin-top: -4px" v-else>₮{{Number(item.price_tug).toLocaleString()}}</span>
                                                 <div class="col-4">
                                                    <span style="background-color: #c90201;font-size: 10px;color:azure;padding:3px 5px; margin: 0 2px 0 0; display: inline-block;" v-if="item.New_lower_price==1"><b>Хямдарсан</b></span>
                                                    <span style="background-color: #dc0951;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0; display: inline-block;" v-if="item.Top_seller==1"><b>Эрэлттэй</b></span>
                                                    <span style="background-color: #cc4f06;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.New==1"><b>ШИНЭ</b></span>
                                                    <span style="background-color: #027bc4;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.IKEA_family_price==1"><b>IKEA family price</b></span>
                                                    <span style="background-color:#fbda11;font-size: 10px;color:black;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.Last_chance==1"><b>Last chance</b></span>
                                                    <div class="flex-center-between mb-1">
                                                         <div v-if="item.Regular_price_tug>item.price_tug" class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                            <ins v-if="item.IKEA_family_price>0" class="font-size-20 ikea-family-price text-decoration-none mr-2">₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                            <ins v-else class="font-size-20 text-red text-decoration-none mr-2">₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                         </div>
                                                         <div v-else class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                             <ins class="font-size-20 text-decoration-none mr-2">
                                                             <span></span> ₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                         </div>
                                                    </div>
                                                 </div>
                                                 <div class="col-4 card-flex-price"> 
                                                     <a href="javascript:;" @click="removeFavourite(item.code)" class="text-gray-8 mr-2 ml-4" ><i class="far fa-trash-alt font-size-16"></i></a>
                                                     <a href="javascript:;" @click="addcart(item)" class="add-cart-button"><i class="ec ec-add-to-cart font-size-12" style="color: #ebebeb"></i></a>
                                                 </div>
                                            </div>
                                        </div>
                     </div>
                     <div class="mb-8 cart-total col-md-4 col-sm-4 mt-3" align="center">
                           <div class="row card p-5">
                                <div class="col-md-12">
                                    <div> 
                                        <img :src="user.img" style="width: 90px;height: auto;margin-bottom: 20px;">
                                        <div class="flex-info"> 
                                            <span> Миний бонус</span><span>₮{{user.bonus}}</span>
                                        </div>
                                        <div class="flex-info"> 
                                            <span> Миний захиалга</span><span>{{order.length}}</span>
                                        </div>
                                        <div class="flex-info"> 
                                            <span> Хадгалсан</span><span>{{saved.length}}</span>
                                        </div>
                                    </div>
                                    <form @submit.prevent="updateUser">
                                        <div class="row">
                                                <span class="ml-8 mt-4">Хувийн мэдээлэл</span>
                                                <div class="col-md-12 flex" >
                                                    <div class="card-flex"><img src="@/assets/images/login/user2.png" class="info-img"></div>
                                                    <input type="name" class="info-input" v-model="info.name" placeholder="Нэр">
                                                </div>
                                                <div class="col-md-12 mt-2 flex">
                                                    <div class="card-flex"><img src="@/assets/images/login/mail.png" class="info-img"></div>
                                                    <input type="email" class="info-input" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" v-model="info.email" placeholder="Имэйл" title="Зөв имэйл оруулна уу" required>
                                                </div>
                                                <div class="col-md-12 mt-2 flex">
                                                    <div class="card-flex"><img src="@/assets/images/login/call.png" class="info-img"></div>
                                                    <input type="text" class="info-input" v-model="info.phone" pattern="^(8|9)[0-9]{7}$" placeholder="Гар утасны дугаар" title="Та 8 эсвэл 9-өөр эхэлсэн, нийт 8 оронтой дугаар оруулна уу" required>
                                                    <!-- <el-input required pattern="[0-9]{8}" placeholder="Утасны дугаар" v-model="info.phone" clearable></el-input> -->
                                                </div>
                                                <!-- <div class="col-md-12 mt-3"><el-input pattern="[0-9]{8}" placeholder="Утасны дугаар 2 (заавал биш)" v-model="info.phone2" clearable></el-input></div> -->
                                                <div class="col-md-12"></div>
                                                <div class="col-md-12 flex">
                                                    <div class="info-img"> </div>
                                                    <button type="submit" class="btn btn-primary-dark-w mt-2 info-button" >Хадгалах</button>
                                                </div>
                                            </div>  
                                    </form>
                                    <form @submit.prevent="changePassword">
                                                <div class="row mt-4">
                                                    <!-- <div class="col-md-12" align="center">
                                                        <i class="fas fa-unlock-alt fa-3x mb-3"></i>
                                                    </div> -->
                                                    <div><span class="ml-8">нууц үг</span></div>
                                                    <div class="col-md-12"></div>
                                                    <div class="col-md-12 flex">
                                                        <div class="info-img"></div><div style="width: 100%;position: relative;"> 
                                                        <input class="info-input" type="password"  ref="pass1" placeholder="Шинэ нууц үг" v-model="password"> 
                                                        <input class="pass-show" type="checkbox" @click="showpass('pass1')">
                                                    </div>
                                                    </div>
                                                    <div class="col-md-12"></div>
                                                    <div class="col-md-12"></div>
                                                    <div class="col-md-12 mt-2 flex">
                                                        <div class="info-img"></div><div style="width: 100%;position: relative;"> 
                                                            <input class="info-input" type="password"  ref="pass2" placeholder="Давтан нууц үг" v-model="confirmPassword">
                                                            <input class="pass-show" type="checkbox" @click="showpass('pass2')">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12"></div>
                                                    <div class="col-md-12"></div>
                                                    <div class="col-md-12 mt-2 flex"><div class="info-img"></div>
                                                        <button type="submit" class="btn btn-primary-dark-w mt-2 info-button">Хадгалах</button>
                                                    </div>
                                                </div>
                                     </form>
                                </div>
                            </div>
                     </div>
                </div>
            </div>
        </main>
        <Brands />
    </div>
</template>
<script>
import Brands from "@/components/brands";
export default {
    components: {
        Brands
    },
    data() {
        return {
            fullscreenLoading: false,
            user: [],
            info: {
                name: '',
                phone: '',
                email: '',
                phone2: ''
            },
            password: '',
            confirmPassword: '',
            saved: [],
            order: [],
            role: undefined
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.role = to.query.role;
        this.getUser();
        next();
    },
    mounted() {
        this.role = this.$route.query.role;
        this.$emit('getJquery');
        this.getUser();
    },
    methods: {
        addcart(item) {
            this.$emit('addCart', [1, item]);
        },
        showpass(val){
           let t=this.$refs[`${val}`].type;
           if(t=='password'){
            this.$refs[`${val}`].type='text'
           }else{
            this.$refs[`${val}`].type='password'
           }
        },
        removeFavourite(id) {
            const token = localStorage.getItem('token');
            var rts = this;
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/product/remove-favourite',
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    id: id
                }
            }).then(data => {
                rts.saved.forEach((el, index) => {
                    if(id == el.code) {
                        rts.saved.splice(index,1);
                    }
                });
            });
        },
        changePassword() {
            if(this.password != this.confirmPassword) {
                this.$notify({
                    title: 'Амжилтгүй',
                    message: `Давтан нууц үг буруу`,
                    type: 'error'
                });
            } else {
                const token = localStorage.getItem('token');
                var rts = this;
                rts.$axios({
                    method: 'POST',
                    url: rts.$appUrl + '/api/user/change-password',
                    headers: {
                        "Authorization": `Bearer ${token}`
                    },
                    data: {
                        password: this.password
                    }
                }).then(data =>{
                    rts.$notify({
                        title: 'Амжилттай',
                        message: `Нууц үг шинэчлэгдлээ`,
                        type: 'success'
                    });
                });
            }
        },
        updateUser() {
            const token = localStorage.getItem('token');
            var rts = this;
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/user/update-info',
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    info: this.info
                }
            }).then(data => {
                let user = JSON.parse(localStorage.getItem('user'));
                user.email = rts.info.email;
                user.name = rts.info.name;
                user.phone = rts.info.phone;
                user.phone2 = rts.info.phone2;
                localStorage.user = JSON.stringify(user);
                rts.user.name = rts.info.name;
                rts.user.email = rts.info.email;
                rts.user.phone = rts.info.phone;
                rts.user.phone2 = rts.info.phone2;
                rts.$emit('updateUser');
                rts.$notify({
                    title: 'Амжилттай',
                    message: `Мэдээлэл шинэчлэгдлээ`,
                    type: 'success'
                });
            });
        },
        changeActivity(value) {
            var tabs = ['password', 'saved', 'info', 'orders'];
            tabs.forEach(element => {
                if(element == value) {
                    this.$refs[element].classList.add('active');
                    this.$refs[element+'1'].classList.add('active');
                } else {
                    this.$refs[element].classList.remove('active');
                    this.$refs[element+'1'].classList.remove('active');
                }
            });
        },
        getUser() {
            const token = localStorage.getItem('token');
            var rts = this;
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/user/my-info',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(data => {
                rts.saved = data.data.save;
                rts.order = data.data.order;
                rts.user = data.data.info[0];

                rts.info.name = data.data.info[0].name;
                rts.info.email = data.data.info[0].email;
                rts.info.phone = data.data.info[0].phone;
                rts.info.phone2 = data.data.info[0].phone2;
            }).catch(err => {
                rts.$router.push('/error-page');
            });
            if(this.role == 'saved') {
                const el = document.getElementById("saved1");
                el.click();
            }
        }
    }
}
</script>